import React from 'react';
import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import CreateMeltingRequest from '../../../pages/MeltingRequest/CreateMeltingRequest/CreateMeltingRequest';
import MeltingRequestList from '../../../pages/MeltingRequest/MeltingRequestList/MeltingRequestList';


function MeltingRequestRoute() {
    // prefix of this route
    // melting
    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/create-melting-request" element={<CreateMeltingRequest />} />
                <Route path="/melting-request-list" element={<MeltingRequestList />} />


                

            </Route>
        </Routes>
    );
}

export default MeltingRequestRoute;
